import React from 'react';
import { usePathValidations } from '../../LearningPaths.utils';
import { useLearningPathsStore } from '../../LearningPaths.store';
import DottedBtn from 'shared_ui_components/DottedBtn/DottedBtn';
import { useGetFF } from '@fstack-tech/ff_react_module';
import FocusDottedBtn from 'shared_ui_components/DottedBtn/FocusDottedBtn';

const AddContentBtn = ({ label = 'Add resource', onClick = () => null}) => {
  const { learningPath } = useLearningPathsStore();
  const { isPathOwner } = usePathValidations({ learningPath });
    const { isEnabled: ff_learningPaths } = useGetFF({ flag_id: 'learning_paths' });

  if (!isPathOwner) return null;
  // if (!ff_learningPaths) 
  return <DottedBtn onClick={onClick} showPlusSign label={label} />;
  // else return <FocusDottedBtn onClick={onClick} showPlusSign label={label} learningPath={learningPath}/>;
};

export default AddContentBtn;
